import { loadProducts } from "../services/productService";
import { mapProductDtoArrayToRows } from "../mappers/productMapper";
import type { ProductRow } from "../routes/products/route";

export interface ProductLoaderParams {
  page?: string;
  size?: string;
  showExpired?: string;
  showPrimaryCharacteristic?: string;
  productCode?: string;
  productName?: string;
  productGroupCode?: string;
  ingangsdatum?: string;
  gewasnummer?: string;
}

export interface MappedProductResult {
  value: ProductRow[];
  "@odata.count": number;
  error?: {
    message: string;
    statusCode?: number;
  };
}

/**
 * Loads products using the Kiota client with OData support
 */
export async function loadProductsData(
  searchParams: ProductLoaderParams,
): Promise<{ deferredData: Promise<{ data: MappedProductResult }> }> {
  const page = searchParams.page ? parseInt(searchParams.page, 10) : 1;
  const pageSize = searchParams.size ? parseInt(searchParams.size, 10) : 10;
  const expired = searchParams.showExpired === "true";
  const hasPrimaryCharacteristic =
    searchParams.showPrimaryCharacteristic === "true"
      ? false
      : undefined;

  const deferredData = loadProducts({
    page,
    pageSize,
    expired,
    hasPrimaryCharacteristic,
    productCode: searchParams.productCode,
    productName: searchParams.productName,
    productGroupCode: searchParams.productGroupCode,
    ingangsdatum: searchParams.ingangsdatum,
    gewasnummer: searchParams.gewasnummer,
  }).then((data) => ({
    data: {
      value: mapProductDtoArrayToRows(data.value),
      "@odata.count": data["@odata.count"] ?? 0,
      error: data.error,
    },
  }));

  return {
    deferredData,
  };
}
